export default class ObjectFitController {
  constructor (
    containerElement,
    fittedElement,
    options = {
      fitting: 'cover', // 'cover' | 'contain'
      aspectRatio: 'initial', // number (width divided by height) | 'initial' (to get the aspect ratio by the fittedElement's initial size) | 'attributes' (to get the aspect ratio by the fittedElement's width and height attributes)
      result: 'css' // 'css' (css properties width and height get set) | 'attributes' (width and height attributes get set) | function(width, height) (function gets called with the new width and height)
    }) {
    this._containerElement = containerElement
    this._fittedElement = fittedElement
    this._settings = options

    // Determine aspect ratio
    switch (this._settings.aspectRatio) {
      case 'attributes':
        this._aspectRatio =
        parseInt(this._fittedElement.getAttribute('width')) /
        parseInt(this._fittedElement.getAttribute('height'))
        break
      case 'initial': {
        const rect = this.fittedElement.getBoundingClientRect()
        this._aspectRatio = rect.width / rect.height
        break
      }
      default:
        // Assuming correct use, the aspectRatio should be a number > 0
        this._aspectRatio = this._settings.aspectRatio
    }

    this._bindUIActions()
  }

  _calcCoverSize (containerWidth, containerHeight, objectAspectRatio) {
    const containerAspect = containerWidth / containerHeight
    const width =
      containerAspect > objectAspectRatio
        ? containerWidth
        : containerHeight * objectAspectRatio
    const height =
      containerAspect > objectAspectRatio
        ? containerWidth / objectAspectRatio
        : containerHeight
    return {
      width,
      height
    }
  }

  _calcContainSize (containerWidth, containerHeight, objectAspectRatio) {
    const containerAspect = containerWidth / containerHeight
    const width =
      containerAspect > objectAspectRatio
        ? containerHeight * objectAspectRatio
        : containerWidth
    const height =
      containerAspect > objectAspectRatio
        ? containerHeight
        : containerWidth / objectAspectRatio
    return {
      width,
      height
    }
  }

  _calcNewSize () {
    // Get container size
    const containerRectangle = this._containerElement.getBoundingClientRect()
    const containerWidth = containerRectangle.width
    const containerHeight = containerRectangle.height

    if (this._settings.fitting === 'contain') {
      return this._calcContainSize(
        containerWidth,
        containerHeight,
        this._aspectRatio
      )
    } else { // cover
      return this._calcCoverSize(
        containerWidth,
        containerHeight,
        this._aspectRatio
      )
    }
  }

  _applyNewObjectSize (newObjectSize) {
    if (typeof this._settings.result === 'function') {
      try {
        this._settings.result(newObjectSize.width, newObjectSize.height)
      } catch (e) {
        console.error(e.name + ': ' + e.message)
      }
    } else if (this._settings.result === 'attributes') {
      this._fittedElement.setAttribute('width', newObjectSize.width)
      this._fittedElement.setAttribute('height', newObjectSize.height)
    } else {
      this._fittedElement.style.width = newObjectSize.width + 'px'
      this._fittedElement.style.height = newObjectSize.height + 'px'
    }
  }

  update () {
    const newObjectSize = this._calcNewSize()
    this._applyNewObjectSize(newObjectSize)
  }

  start () {
    window.addEventListener('resize', this._updateCallback)
  }

  stop () {
    window.removeEventListener('resize', this._updateCallback)
  }

  _bindUIActions () {
    this.update()

    this._updateCallback = () => {
      this.update()
    }
    window.addEventListener('resize', this._updateCallback)
  }
}
